var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09773 0.438992C9.3599 0.457718 9.57526 0.560715 9.7438 0.74798C9.89361 0.953973 9.93106 1.19742 9.85615 1.47832L8.36739 6.73113H10.755C11.0359 6.73113 11.27 6.82476 11.4573 7.01203C11.6445 7.19929 11.7382 7.43337 11.7382 7.71427C11.7382 8.0139 11.6258 8.26671 11.4011 8.4727L4.12582 14.6244C3.976 14.7555 3.7981 14.821 3.59211 14.821C3.32994 14.8023 3.11458 14.6993 2.94604 14.512C2.79623 14.306 2.75878 14.0626 2.83368 13.7817L4.32245 8.52888H1.90672C1.62582 8.52888 1.4011 8.43525 1.23256 8.24798C1.04529 8.07944 0.95166 7.85472 0.95166 7.57382C0.95166 7.29292 1.06402 7.05884 1.28874 6.87158L8.56402 0.635621C8.71383 0.504535 8.89174 0.438992 9.09773 0.438992ZM8.08649 2.82663L2.97413 7.18056H5.22132C5.44604 7.18056 5.62394 7.2742 5.75503 7.46146C5.88612 7.63 5.92357 7.82663 5.86739 8.05135L4.60335 12.4615L9.77188 8.07944H7.46851C7.2438 8.07944 7.06589 7.99517 6.93481 7.82663C6.80372 7.63937 6.76627 7.44274 6.82245 7.23674L8.08649 2.82663Z",
    fill: "#003768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.69,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15.13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolt);
export default __webpack_public_path__ + "static/media/volt.842dc73bdce5438a1387818563119293.svg";
export { ForwardRef as ReactComponent };